module.exports = __webpack_public_path__ + "media/images/corporate-sales/icons/apparel-branding-8cc8bf19af0784a4a87798b0e81960ee.svg";